import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import './Grid.module.css';

class GridContainer extends PureComponent {
  render() {
    const { containerType, classes, styles, children } = this.props;

    const styleNames = ['grid-container'];
    if (containerType) {
      styleNames.push(containerType);
    }
    return (
      <div
        className={classes}
        styleName={classNames(styleNames)}
        style={styles}
      >
        {children}
      </div>
    );
  }
}

GridContainer.propTypes = {
  /** If provided, determines the type of grid container. */
  containerType: PropTypes.oneOf(['full', 'fluid']),
  classes: PropTypes.any,
  styles: PropTypes.any,
  children: PropTypes.any
};

export default DisplayComponent(GridContainer);
